<template>
	<div>
		<data-table
			title=""
			:columns="headers"
			:rows="$clients"
			v-on:row-click="onShowClientInfo"
			class="m-data-table tw-mt-7 tw-w-full tw-overflow-auto scrollbar-x tw-rounded"
		>
			<template #[`item.actions`]="{ item }">
				<td>
					<b-button-group
						size="sm"
						class="tw-shadow-none"
					>
						<b-button
							variant="success"
							@click="onInitUpdateItem(item)"
						>Update</b-button>
						<b-button
							variant="danger"
							@click="onDeleteItem(item)"
						>Delete</b-button>
					</b-button-group>
				</td>
			</template>
			<template #[`item.role`]="{ item }">
				<td>
					<div class="tw-flex tw-space-x-1">
						<span
							v-for="role in item.role"
							:key="role"
							class="tw-text-white tw-py-1 tw-px-2 tw-text-xs tw-rounded-full"
							:class="{
									'tw-bg-green-500': role === role.ADMIN,
									'tw-bg-purple-500': role === role.PERITO,
									'tw-bg-pink-500': role === role.CLIENT
								}"
						>
							{{ role }}
						</span>
					</div>
				</td>
			</template>
		</data-table>
	</div>
</template>

<script>
import { ROLES } from '../../consts'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTable from "vue2-matable"

export default {
	name: 'ClientsTable',
	components: {
		DataTable,
	},
	data: () => ({
		// Booleans

		// Objects

		// Array
		role: ROLES,
		headers: [
			{
				field: 'institution',
				label: 'Institucion',
			},
			{
				field: 'client',
				label: 'Cliente',
			},
			{
				field: 'contact',
				label: 'Contacto',
			},
			{
				field: 'phone',
				label: 'Telefono',
			},
			{
				field: 'email',
				label: 'Correo',
			},
			// {
			// 	field: 'role',
			// 	label: 'Roles',
			// },
			{
				field: 'actions',
				label: 'Actions',
			},
		],

		// Functions
		onShowClientInfo: () => { },
	}),
	computed: {
		...mapGetters('clients', ['$clients']),
	},
	created() {
		this.subscribeClients()
	},
	methods: {
		...mapMutations('clients', ['SET']),
		...mapActions('clients', ['subscribeClients']),
		onInitUpdateItem(item) {
			this.SET({
				client: item,
				isUpdate: true
			})
		},
		onDeleteItem(item) {
			if (confirm('Do you want to delete this item?')) {
				item.ref.delete()
			}
		}
	}
}
</script>
